//Bot/apiDefinitions.js

export const apiDefinitions = {
 acoes: [
  {
   apiId: 1,
   label: "Enviar mensagem",
   description: "Envia uma mensagem de texto, voz ou outro tipo para o contato.",
   apiType: 'action',
   parameters: [
    { id: "Parametro1", name: "Mensagem", type: "array-text" },
    { id: "Parametro2", name: "URL (Retorno)", type: "text", placeholder: "Ex: https://api.example.com/callback" },
    { id: "canal", name: "Canal", type: "radio", options: [{ value: 'canal_atual', title: 'Canal atual' }, { value: 'whatsapp', title: 'Whatsapp' }, { value: 'email', title: 'E-mail' }, { value: 'sms', title: 'SMS' }, { value: 'voz', title: 'Voz' }], defaultValue: 'canalatual' },
    { id: "numerolinha", name: "Número Origem (por onde a mensagem será enviada)", type: "options", options: [{title: "11-99xxxxx", value: "7286"}, {title: "Informar manualmente", value: "manual"}], depends_on: "canal", depends_on_value: "whatsapp" },
    { id: "numerolinhamanual", name: "Informe o número da linha (com DDD)", type: "string", depends_on: "numerolinha", depends_on_value: "manual" },
    { id: "templatewhatsapp", name: "Template de WhatsApp", type: "options", options: [{title: "abacate500", value: "203766"}, {title: "carrinho_abandonado", value: "90417"}, {title: "carrinnho_abandonado", value: "203765"}, {title: "janela_24hs", value: "90418"}, {title: "teste_v1", value: "203767"}], depends_on: "canal", depends_on_value: "whatsapp" },
    { id: "mensagemtemplatewhatsapp", name: "Mensagem customizada de template (não obrigatório)", type: "string", depends_on: "templatewhatsapp", depends_on_value: null },
    { id: "legendaarquivowhatsapp", name: "Legenda para o arquivo", type: "string", depends_on: "canal", depends_on_value: "whatsapp" },
    { id: "templateemail", name: "Template de E-mail", type: "options", options: [{title: "Carrinho Abandonado", value: "1093"}], depends_on: "canal", depends_on_value: "email" },
    { id: "diasadiamentodisparo", name: "Adiar o envio (quantidade de dias)", type: "integer" },
    { id: "horadisparoadiado", name: "Horário para envio", type: "hour", depends_on: "diasadiamentodisparo", depends_on_value: null }
   ]
  },
  {
   apiId: 2,
   label: "Aguardar mensagem de resposta",
   description: "Espera por uma resposta do usuário e define um tempo limite.",
   apiType: 'action',
   parameters: [
    { id: 'ParametrosVoice', name: 'Informar parâmetros para bot de voz', type: 'radio', options: [{ value: 'nao', title: 'Não' }, { value: 'sim', title: 'Sim' }], defaultValue: 'nao' },
    { id: 'grammar', name: 'Tipo de reconhecimento esperado', type: 'options', options: [{value: 'fala_livre', title: 'POR FALA LIVRE'}, {value: 'dtmf', title: 'POR DTMF'}, {value: 'dtmf_3dig_cpf', title: 'POR DTMF (3DIG CPF)'}, {value: 'dtmf_menu', title: 'POR DTMF (MENU)'}, {value: 'fala_livre_doc', title: 'DOCUMENTO COM FALA LIVRE'}, {value: 'fala_livre_doc_3_dig', title: '3 DIGITOS COM FALA LIVRE OU DTMF'}, {value: 'fala_livre_dtmf', title: 'FALA LIVRE E/OU DTMF'}, {value: 'fala_livre_phone', title: 'TELEFONE COM FALA LIVRE'}, {value: 'fala_livre_car', title: 'PLACA DE VEÍCULO COM FALA LIVRE'}, {value: 'obtemcpc.gram', title: "TERMOS PARA 'CPC'"}, {value: 'simnao.gram', title: "'SIM' OU 'NAO'"}, {value: 'simnaowhats.gram', title: "'SIM', 'NAO' OU 'WHATSAPP'"}, {value: 'telefoneorwhatsapp.gram', title: "'WHATSAPP' OU 'TELEFONE'"}, {value: 'agentorwhats.gram', title: "'AGENTE' OU 'WHATSAPP'"}, {value: 'continuarorwhatsapp.gram', title: "'CONTINUAR' OU 'WHATSAPP'"}, {value: 'cpf3pv2.gram', title: "CPF"}, {value: 'cpf.gram', title: "CNPJ"}, {value: 'boolean.gram', title: "'VERDADEIRO' OU 'FALSO'"}, {value: 'code.gram', title: "NÚMEROS E RETORNAR NUMERAL"}, {value: 'date.gram', title: "RETORNA UMA DATA"}, {value: 'alphacode.gram', title: "NÚMEROS E RETORNAR POR EXTENSO"}, {value: 'voceconhece.gram', title: "TERMOS LIGADOS A QUESTAO 'VOCÊ CONHECE'"}, {value: 'datasouparcelamentos.gram', title: "'NOVA DATA' OU 'PARCELAMENTO'"}, {value: 'avistaparcelado.gram', title: "'A VISTA' OU 'PARCELADO'"}, {value: 'podenaopode.gram', title: "'PODE ENVIAR SMS/BOLETO'"}, {value: 'podeenviarcodbarras.gram', title: "'PODE ENVIAR CODIGO DE BARRAS'" }]},
    { id: 'confidence', name: 'Confiança no resultado (padrão MÉDIA)', type: 'select', options: [{ value: 'BAIXA', title: 'Baixa' }, { value: 'MEDIA', title: 'Média' }, { value: 'ALTA', title: 'Alta' }, { value: 'MUITOALTA', title: 'Muito Alta' }], defaultValue: '' },
    { id: 'timeout', name: 'Tempo máximo (segundos) para aguardar resposta (padrão 5 segundos)', type: 'integer', defaultValue: '', depends_on: 'Informar parâmetros para bot de voz', depends_on_value: 'sim' }
   ]
  },
  {
   apiId: 3,
   label: "Vincular segmento ao contato (identificar por mensagem do contato)",
   description: "Com base na resposta do contato faz o reconhecimento do segmento que o mesmo deve ser vinculado.",
   apiType: 'action',
   parameters: [
    // O ID original é 'Manter apenas na nova carteira', mas para ser usado como Parametro1, renomeamos o 'name'
    { id: 'Parametro1', name: 'Manter apenas na nova carteira', type: 'radio' }
   ]
  },
  {
   apiId: 4,
   label: "Vincular segmento ao contato (identificar por API ou variável)",
   description: "Com base no retorno de uma \"Chamada Externa\" tipo GET, ou no valor de uma variável, faz o vinculo do contato com o segmento.",
   apiType: 'action',
   parameters: [
    { id: 'URL Chamada externa / Nome Variável', name: 'Parametro1', type: 'string' },
    { id: 'Manter apenas na nova carteira', name: 'Parametro2', type: 'wallet_unique_confirmation', options: [{value: 'N', title: 'Não'}, {value: 'S', title: 'Sim'}], defaultValue: 'N' }
   ]
  },
  {
   apiId: 5,
   label: "Vincular segmento ao contato (fixo)",
   description: "Insere o contato em um segmento, forçando pelo \"Código do Segmento do contato\" configurado no cadastro de segmento",
   apiType: 'action',
   parameters: [
    // Aqui, os IDs originais foram alterados para 'Parametro1' e 'Parametro2' para corresponder ao seu exemplo
    { id: 'Parametro1', name: 'Carteira', type: 'string' },
    { id: 'Parametro2', name: 'Manter apenas na nova carteira', type: 'radio' }
   ]
  },
  {
   apiId: 6,
   label: "Retirar contato da operação e transferir para atendimento via chatbot",
   description: "Move o contato da fila de atendimento da operação para o Chatbot.",
   apiType: 'action',
   parameters: []
  },
  {
   apiId: 7,
   label: "Finalizar atendimento",
   description: "Finaliza o atendimento pelo chatbot, utilize esta ação para não direcionar o contato para operação até que ele envie uma nova mensagem.",
   apiType: 'action',
   parameters: [
    { id: 'Parametro1', name: 'Manter operador fidelizado se houver', type: 'radio', options: [{value: 'N', title: 'Não'}, {value: 'S', title: 'Sim'}], defaultValue: 'N' }
   ]
  },
   {
   apiId: 8,
   label: "Enviar contato para a fila da operação",
   description: "Se o contato já estiver fidelizado com um atendente, apenas marque o contato como pendente de resposta para que seja destacado na fila do atendente.",
   apiType: 'action',
   parameters: [
    {
     id: 'Parametro1',
     name: 'Se contato estiver fidelizado com um operador',
     type: 'radio', 
     options: [
      { value: 'N', title: 'Desfidelizar e enviar para a fila geral' },
      { value: 'S', title: 'Manter com o operador e marcar como pendente' },
      { value: 'M', title: 'Manter com o operador e marcar como não pendente' }
     ],
     defaultValue: 'N'
    },
    {
     id: 'Parametro2',
     name: 'Zerar horário de início da pendência',
     type: 'radio', // <- Alterado para 'radio'
     options: [
      { value: 'nao', title: 'Não' },
      { value: 'sim', title: 'Sim' }
     ],
     defaultValue: 'nao'
    },
    {
     id: 'ParametrosVoice',
     name: 'Parâmetros de Voz',
     type: 'radio', // <- Alterado para 'radio'
     options: [
      { value: 'nao', title: 'Não' },
      { value: 'sim', title: 'Sim' }
     ],
     defaultValue: 'nao'
    },
    {
     id: 'TipoOperacao',
     name: 'Tipo de Operação',
     type: 'options',
     options: [
      { value: '', title: 'Selecione...' },
      { value: 'transferencia', title: 'Transferência' },
      { value: 'campanha', title: 'Campanha' }
     ],
     defaultValue: ''
    },
    {
     id: 'DadosTransferenciaVoz',
     name: 'Dados de Transferência de Voz',
     type: 'text',
     placeholder: 'Informe dados adicionais de voz...',
     defaultValue: ''
    },
    {
     id: 'Campanha',
     name: 'Campanha',
     type: 'options',
     options: [
      { value: '', title: 'Selecione uma campanha' },
       
     ],
     defaultValue: ''
    }
   ]
  },
  {
   apiId: 9,
   label: "Enviar contato para um atendente específico",
   description: "Esta ação move o contato que esta em atendimento pelo Chatbot para a fila de um Atendente.",
   apiType: 'action',
   parameters: [
    { id: 'Nome operador', name: 'Parametro1', type: 'string' }
   ]
  },
  {
   apiId: 10,
   label: "Ir para",
   description: "Direciona o contato para um determinado ponto do chatbot com base no \"Identificador da etapa\", ou para um outro fluxo com base no ID (hash) do fluxo",
   apiType: 'action',
   parameters: [
    // Aqui, os IDs originais foram alterados para 'Parametro1' e 'Parametro2' para corresponder ao seu exemplo
    { id: 'Parametro1', name: 'Identificador da etapa', type: 'string' },
    { id: 'Parametro2', name: 'Id do fluxo', type: 'string' }
   ]
  },
  {
   apiId: 11,
   label: "API - Chamada Externa",
   description: "Faz uma chamada para uma API externa.",
   apiType: 'action',
   parameters: [
    { id: 'destino', name: 'Destino', type: 'options-card', options: [{ value: 'api', title: 'API', url_logo: 'https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-api-rest.png' }, { value: 'mercadoPago', title: 'Mercado Pago', url_logo: 'https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-mercado-pago.png' }] },
    // Aqui, o 'id' original 'URL' foi renomeado para 'Parametro1' para atender ao seu pedido de nomenclatura
    { id: 'Parametro1', name: 'URL', type: 'text', depends_on: 'destino', depends_on_value: 'api' },
    { id: 'metodo', name: 'Método', type: 'select', options: [{ value: 'post', title: 'Post' }, { value: 'get', title: 'Get' }, { value: 'put', title: 'Put' }, { value: 'delete', title: 'Delete' }], depends_on: 'destino', depends_on_value: 'api' },
    { id: 'header', name: 'Header', type: 'array-parameters', depends_on: 'destino', depends_on_value: 'api' },
    { id: 'body', name: 'Body', type: 'text', depends_on: 'destino', depends_on_value: 'api' },
    // Aqui, o 'id' original 'Opcional - Timeout (segundos)' foi renomeado para 'Parametro2'
    { id: 'Parametro2', name: 'Opcional - Timeout (segundos)', type: 'string', depends_on: 'destino', depends_on_value: 'api' },
    { id: 'modocompatibilidade', name: 'Adicionar na chamada parâmetros GET com dados do contato', type: 'select', options: [{ value: '1', title: 'Sim (Padrão)' }, { value: '2', title: 'Não' }], depends_on: 'destino', depends_on_value: 'api' },
    { id: 'async', name: 'Chamar de forma assíncrona (seguir fluxo sem aguardar o retorno)', type: 'select', options: [{ value: 'sim', title: 'Sim' }, { value: 'nao', title: 'Não (Padrão)' }], depends_on: 'destino', depends_on_value: 'api' },
    { id: 'variavelbodyasync', name: 'Variável (local) que receberá o [response] da chamada assíncrona (cria se não existir)', type: 'string', depends_on: 'async', depends_on_value: 'sim' },
    { id: 'variavelstatuscodeasync', name: 'Variável (local) que receberá o [status code] da chamada assíncrona (cria se não existir)', type: 'string', depends_on: 'async', depends_on_value: 'sim' },
    { id: 'accessToken', name: 'Access Token', type: 'string', depends_on: 'destino', depends_on_value: 'mercadoPago' },
    { id: 'title', name: 'Título', type: 'string', depends_on: 'destino', depends_on_value: 'mercadoPago' },
    { id: 'unit_price', name: 'Preço', type: 'string', depends_on: 'destino', depends_on_value: 'mercadoPago' }
   ]
  },
  {
   apiId: 12,
   label: "Executar bloco de código DovePL",
   description: "Programe livremente em DovePL, linguagem compilada em .NET FrameWork 4.6",
   apiType: 'action',
   parameters: [
    // Aqui, o 'id' original 'Código DovePL' foi renomeado para 'Parametro1'
    { id: 'Parametro1', name: 'Código DovePL', type: 'dove_pl' }
  ]
  },
  {
   apiId: 13,
   label: "Registrar evento",
   description: "Insere um Evento de KPI no Invenio com base no \"Código do Evento\"",
   apiType: 'action',
   parameters: [
    // Aqui, o 'id' original 'Código do Evento' foi renomeado para 'Parametro1'
    { id: 'Parametro1', name: 'Código do Evento', type: 'string' },
    // Aqui, o 'id' original 'Observação (Opcional)' foi renomeado para 'Parametro2'
    { id: 'Parametro2', name: 'Observação (Opcional)', type: 'string' },
    { id: 'Valor', name: 'Valor (Opcional)', type: 'string' }
   ]
  },
  {
   apiId: 14,
   label: "Definir prioridade",
   description: "Define a prioridade de atendimento do contato.",
   apiType: 'action',
   parameters: [
    // Aqui, o 'id' original 'Prioridade' foi renomeado para 'Parametro1'
    { id: 'Parametro1', name: 'Prioridade', type: 'radio', options: [{value: 'BAIXA', title: 'Baixa'}, {value: 'MEDIA', title: 'Média'}, {value: 'ALTA', title: 'Alta'} ] }
   ]
  },
  {
     apiId: 15,
     label: "Aguardar (até tempo de espera ou solicitação externa)",
     description: "Pausa o fluxo até que o tempo de espera seja alcançado ou que uma chamada externa por API seja feita, solicitando a continuidade do fluxo.",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'Tempo de espera' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Tempo de espera', type: 'string' },
      // Aqui, o 'id' original 'UnidadeMedida' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Unidade de medida', type: 'select', options: [{value: 'segundos', title: 'Segundos (mínimo 10)'}, {value: 'minutos', title: 'Minutos'}, {value: 'horas', title: 'Horas'}, {value: 'dias', title: 'Dias'} ] }
   ]
  },
  {
     apiId: 16,
     label: "Enviar grupo de botões para Webchat",
     description: "Para canal webchat, envia grupo de botões para o contato clicar. Payload em formato JSON conforme manual.",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'Payload' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Payload', type: 'text' }
   ]
  },
  {
     apiId: 17,
     label: "Pesquisar mensagem recebida na base de conhecimento",
     description: "Verifica se a mensagem recebida do contato satisfaz condição de algum artigo já existente na base de conhecimento.",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'Id da base de conhecimento' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Id da base de conhecimento', type: 'knowledge' }
   ]
  },
  {
     apiId: 18,
     label: "Registrar resposta para curadoria",
     description: "Registra a mensagem recebida do contato para realizar futuro trabalho de curadoria.",
     apiType: 'action',
     parameters: []
  },
  {
     apiId: 19,
     label: "Enviar arquivo",
     description: "Enviar um arquivo",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'Selecione um arquivo' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Selecione um arquivo', type: 'media' },
      // Aqui, o 'id' original 'BASE64 (max. 1MB)' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'BASE64 (max. 1MB)', type: 'string' },
      { id: 'URL', name: 'URL do Arquivo', type: 'string' },
      { id: 'nomearquivo', name: 'Nome do arquivo com extensão (opcional)', type: 'string' },
      { id: 'canal', name: 'Canal', type: 'select', options: [{ value: 'canalatual', title: 'Canal atual' }, { value: 'whatsapp', title: 'Whatsapp' }, { value: 'email', title: 'E-mail' }, { value: 'sms', title: 'SMS' }] },
   ]
  },
  {
     apiId: 20,
     label: "Criar ou atualizar variável",
     description: "Cria ou atualiza variáveis para uso no fluxo.",
     apiType: 'action',
     parameters: [
      // IDs corretos para corresponder ao JSON da IDR
      { id: 'nomevariavel', name: 'Nome da variável', type: 'string' },
      { id: 'valorvariavel', name: 'Conteúdo/Valor', type: 'textarea' },
      { id: 'operacao', name: 'Operação', type: 'radio', options: [{ title: "Salvar", value: "salvar" }, { title: "Adicionar", value: "adicionar" }, { title: "Subtrair", value: "subtrair" }, { title: "Multiplicar", value: "multiplicar" }, { title: "Dividir", value: "dividir" }] },
      { id: 'tipovariavel', name: 'Tipo de variável', type: 'select', options: [{ title: "Local", value: "local" }, { title: "Ambiente", value: "ambiente" }], defaultValue: 'local' }
   ]
  },
  {
     apiId: 21,
     label: "Salvar dados do contato",
     description: "Salva um dado do contato com base em valor fixo ou variável.",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'nomedado' foi renomeado para 'Parametro1'
      {
       id: 'Parametro1', name: 'Dado', type: 'options',
       options: [
        { title: "Nome", value: "nomepessoa" },
        { title: "Identificação (RG, CPF, CNPJ, RNE, etc)", value: "cpfcnpj" },
        { title: "Código do Cliente", value: "codpessoacliente" },
        { title: "E-Mail", value: "enderecoemail" },
        { title: "Telefone", value: "numerotelefone" },
        { title: "Tag", value: "tagpessoa" },
        { title: "Campo coringa 1", value: "coringa1" },
        { title: "Campo coringa 2", value: "coringa2" },
        { title: "Campo coringa 3", value: "coringa3" },
        { title: "Campo coringa 4", value: "coringa4" },
        { title: "Campo coringa 5", value: "coringa5" }
      ]
      },
      // Aqui, o 'id' original 'valordado' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Conteúdo', type: 'string' }
   ]
  },
  {
     apiId: 22,
     label: "Enviar botões de resposta para WhatsApp",
     description: "Envia uma mensagem com botões de resposta no WhatsApp.",
     apiType: 'whatsappButtons',
     nodeType: 'whatsappButtonNode',
     parameters: [
      // Aqui, o 'id' original 'headerType' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Tipo de Cabeçalho', type: 'radio', options: [{ value: 'text', title: 'Texto' }, { value: 'image', title: 'Imagem' }], defaultValue: 'text' },
      // Aqui, o 'id' original 'headerText' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Texto do Cabeçalho', type: 'textarea', maxLength: 60, rows: 2 },
      { id: 'headerImageUrl', name: 'URL da Imagem', type: 'text' },
      { id: 'description', name: 'Descrição', type: 'textarea', maxLength: 1024, rows: 4, defaultValue: 'Escolha uma opção:' },
      { id: 'footer', name: 'Rodapé (Opcional)', type: 'textarea', maxLength: 60, rows: 2 },
      { id: 'buttons', name: 'Botões', type: 'whatsapp_buttons' }
   ]
  },
  {
     apiId: 23,
     label: "Enviar lista interativa para WhatsApp",
     description: "Envia uma mensagem com uma lista interativa no WhatsApp.",
     apiType: 'interactiveList',
     nodeType: 'interactiveList',
     parameters: [
      // Aqui, o 'id' original 'headerType' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Tipo de Cabeçalho', type: 'radio', options: [{ value: 'text', title: 'Texto' }, { value: 'image', title: 'Imagem' }, { value: 'video', title: 'Vídeo' }], defaultValue: 'text' },
      // Aqui, o 'id' original 'headerText' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Texto do Cabeçalho', type: 'textarea', maxLength: 60, rows: 2 },
      { id: 'headerImageUrl', name: 'URL da Imagem', type: 'text' },
      { id: 'headerVideoUrl', name: 'URL do Vídeo', type: 'text' },
      { id: 'description', name: 'Descrição', type: 'textarea', maxLength: 1024, rows: 4, defaultValue: 'Escolha uma opção:' },
      { id: 'footer', name: 'Rodapé (Opcional)', type: 'textarea', maxLength: 60, rows: 2 },
      { id: 'sections', name: 'Seções', type: 'interactive_list_sections' }
   ]
  },

  {
     apiId: 24,
     label: "Cartão de Pipeline (Beta)",
     description: "Crie e atualize cartões, adicione comments e anexos em seus Pipelines",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'ParametroPipelineAcao' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Informe uma ação', type: 'select', options: [{value: 'add_card', title: 'Criar um cartão'}, {value: 'alter_card', title: 'Atualizar descrição'}, {value: 'add_comment', title: 'Adicionar um comentário'}, {value: 'add_file', title: 'Adicionar anexo'}, {value: 'change_step', title: 'Trocar coluna/lista'}], defaultValue: 'add_card' },
      { id: 'ParametroPipelineId', name: 'Pipelines', type: 'pipelines', depends_on: 'ParametroPipelineAcao', depends_on_value: 'add_card' },
      { id: 'ParametroPipelineStepId', name: 'Lista', type: 'pipeline_steps', depends_on: 'ParametroPipelineAcao', depends_on_value: 'add_card' },
      // Aqui, o 'id' original 'ParametroCardCustomId' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Identificação do cartão', type: 'string', depends_on: 'ParametroPipelineAcao', depends_on_value: ['alter_card', 'add_comment', 'add_card', 'add_file', 'change_step'] },
      { id: 'ParametroCardDescription', name: 'Descrição do cartão', type: 'textarea', depends_on: 'ParametroPipelineAcao', depends_on_value: ['alter_card', 'add_card'] },
      { id: 'ParametroCardComment', name: 'Comentário', type: 'textarea', depends_on: 'ParametroPipelineAcao', depends_on_value: 'add_comment' },
      { id: 'ParametroCardFile', name: 'Selecionar um arquivo', type: 'media', depends_on: 'ParametroPipelineAcao', depends_on_value: 'add_file' },
      { id: 'ParametroCardFileBase64', name: 'BASE64 (max. 1MB)', type: 'string', depends_on: 'ParametroPipelineAcao', depends_on_value: 'add_file' },
      { id: 'ParametroPipelineId-changestep', name: 'Pipelines', type: 'pipelines', depends_on: 'ParametroPipelineAcao', depends_on_value: 'change_step' },
      { id: 'ParametroPipelineStepId-changestep', name: 'Lista', type: 'pipeline_steps', depends_on: 'ParametroPipelineAcao', depends_on_value: 'change_step' }
   ]
  },
  {
     apiId: 25,
     label: "Desligar chamada de voz",
     description: "Desliga a chamada de voz atual",
     apiType: 'action',
     parameters: []
  },
  {
     apiId: 26,
     label: "Fazer tabulação de voz",
     description: "Registra tabulação para correta parametrização de discadores e visualização de dashboards",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'tabulacao' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Selecione o tipo de Tabulação', type: 'select', options: [{value: '', title: '<NENHUMA TABULAÇÃO RETORNADA DA VOICE>'}] },
      // Aqui, o 'id' original 'insights' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Dados customizados para Insights (JSON)', type: 'text' }
   ]
  },
  {
     apiId: 27,
     label: "Enviar contato para a lista de restrição",
     description: "Registra o contato na lista de restrição do canal atual para que ele não receba mais mensagens",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'Motivo da restrição' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Motivo da restrição', type: 'text' },
      // Aqui, o 'id' original 'Inserir apenas no segmento atual?' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Inserir apenas no segmento atual?', type: 'radio', options: [{value: 'N', title: 'Não'}, {value: 'S', title: 'Sim'}], defaultValue: 'N' }
   ]
  },
  {
     apiId: 28,
     label: "Enviar flow de WhatsApp",
     description: "Envia flow de WhatsApp",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'whatsappflow' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Whatsapp Flow', type: 'whatsapp_flow', options: [{title: 'TEste', value: 'E15BC7190A120226'}, {title: 'REsre', value: 'DEA7E8647DD67D22'}] },
      // Aqui, o 'id' original 'whatsappflowscreen' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Tela', type: 'whatsapp_flow_screens' },
      { id: 'body', name: 'Corpo da mensagem', type: 'text' },
      { id: 'button', name: 'Texto do botão', type: 'string' }
   ]
  },
  {
     apiId: 29,
     label: "Enviar botão de pagamento no WhatsApp",
     description: "Envia botão de pagamento no WhatsApp",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'body' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Corpo da mensagem', type: 'text' },
      // Aqui, o 'id' original 'referenceid' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'ID de referência', type: 'string' },
      { id: 'pixcode', name: 'Código PIX Copia e Cola', type: 'string' },
      { id: 'productname', name: 'Nome do produto', type: 'string' },
      { id: 'productquantity', name: 'Quantidade', type: 'string' },
      { id: 'productvalue', name: 'Valor', type: 'string' }
   ]
  },
  {
     apiId: 30,
     label: "Enviar status de pedido no WhatsApp",
     description: "Envia status de pedido no WhatsApp",
     apiType: 'action',
     parameters: [
      // Aqui, o 'id' original 'body' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Corpo da mensagem', type: 'text' },
      // Aqui, o 'id' original 'referenceid' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'ID de referência', type: 'string' },
      { id: 'description', name: 'Descrição do status do pedido (opcional)', type: 'string' }
   ]
  },
  {
     apiId: 31,
     label: "Enviar mensagem de preferences de ligação por WhatsApp",
     description: "Envia opções para o usuário definir se aceita ligações via WhatsApp.",
     apiType: 'action',
     parameters: []
  },
  {
     apiId: 99,
     apiType: 'action',
     nodeType: 'actionNode',
     label: 'Webhook',
     description: 'Envia uma requisição HTTP para uma URL externa.',
     type: 'webhook',
     parameters: [
      {
       'name': 'webhookName',
       'label': 'Nome do Webhook',
       "type": "text",
       "required": true
      },
      {
       "name": "webhookUrl",
       "label": "URL do Webhook",
       "type": "url",
       "required": true
      },
      {
       "name": "webhookMethod",
       "label": "Método HTTP",
       "type": "select",
       "options": [
        { "value": "POST", "label": "POST" },
        { "value": "GET", "label": "GET" },
        { "value": "PUT", "label": "PUT" },
        { "value": "DELETE", "label": "DELETE" }
       ],
       "defaultValue": "POST",
       "required": true
      },
      {
       "name": "webhookHeaders",
       "label": "Headers (JSON)",
       "type": "json",
       "required": false,
       "defaultValue": "{}"
      },
      {
       "name": "webhookBody",
       "label": "Corpo da Requisição (JSON)",
       "type": "json",
       "required": false,
       "defaultValue": "{}"
      }
   ],
   "outputs": [
      {
       "handleId": "out-success",
       "type": "success",
       "label": "Sucesso",
       "connectsTo": ["action", "condition"]
      },
      {
       "handleId": "out-failure",
       "type": "failure",
       "label": "Falha",
       "connectsTo": ["action", "condition"]
      }
   ]
  }
   
 ],
 condicoes: [
  {
     apiId: 2,
     label: "Contato novo ou muito antigo",
     description: "Valida se é a primeira interação com o cliente ou se ultrapassou a quantidade de dias sem interação.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Considerar contato finalizado como novo (S/N)' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Considerar contato finalizado como novo (S/N)', type: 'text' }
   ]
  },
  {
     apiId: 3,
     label: "Possui segmento vinculado ao contato",
     description: "Verifica se o contato já possui um segmento cadastrado.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Carteira' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Carteira', type: 'wallet-multiselect' },
      // Aqui, o 'id' original 'Considerar apenas a mais recente (S/N)' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Considerar apenas a mais recente (S/N)', type: 'string' }
   ]
  },
  {
     apiId: 4,
     label: "Hoje é dia útil",
     description: "Analisa se o dia do atendimento está entre segunda e sexta-feira.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Hora inicial' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Hora inicial', type: 'time' },
      // Aqui, o 'id' original 'Hora final' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Hora final', type: 'time' }
   ]
  },
  {
     apiId: 5,
     label: "Hoje é Sábado",
     description: "Analisa se o dia do atendimento é Sábado.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Hora inicial' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Hora inicial', type: 'time' },
      // Aqui, o 'id' original 'Hora final' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Hora final', type: 'time' }
   ]
  },
  {
     apiId: 6,
     label: "Hoje é Domingo",
     description: "Analisa se o dia do atendimento é Domingo.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Hora inicial' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Hora inicial', type: 'time' },
      // Aqui, o 'id' original 'Hora final' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Hora final', type: 'time' }
   ]
  },
  {
     apiId: 7,
     label: "Atendente disponível",
     description: "Verifica se existe algum usuário logado ou se o usuário fidelizado está disponível.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Checar apenas o fidelizado (S/N)' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Checar apenas o fidelizado (S/N)', type: 'string' }
   ]
  },
  {
  apiId: 8,
  label: "Mensagem possui termo",
  description: "Valida se a resposta contém o termo. Escolha se deseja seguir o fluxo caso seja Verdadeiro ou Falso.",
  apiType: 'condition',
  parameters: [
    { id: 'Termo', name: 'Termo para busca', type: 'string' },
    { 
      id: 'ResultadoEsperado', 
      name: 'Seguir se o resultado for:', 
      type: 'radio', 
      options: [
        { title: 'Verdadeiro', value: 'true' },
        { title: 'Falso', value: 'false' }
      ],
      defaultValue: 'true'
    }
  ]
},
  {
     apiId: 9,
     label: "Mensagem possui termo na lista de restrições",
     description: "Analisa se a resposta do contato possui algum termo cadastrado na lista de restrições.",
     apiType: 'condition',
     parameters: []
  },
  {
     apiId: 10,
     label: "Última ação executada retornou sucesso",
     description: "Verifica se a etapa anterior foi concluída com sucesso.",
     apiType: 'condition',
     parameters: []
  },
  {
     apiId: 11,
     label: "Contato muito tempo aguardando resposta da operação",
     description: "Conta quanto tempo o contato está em espera, aguardando interação dos operadores.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de minutos inicial' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de minutos inicial', type: 'number' },
      // Aqui, o 'id' original 'Quantidade de minutos final' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Quantidade de minutos final', type: 'number' }
   ]
  },
  {
     apiId: 12,
     label: "Contato incluído por mailing",
     description: "Verifica se contato entrou no sistema através da importação de um público.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de dias desde a inclusão' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de dias desde a inclusão', type: 'string' }
   ]
  },
  {
     apiId: 13,
     label: "Mensagem retorno última chamada externa possui termo",
     description: "Confere se a chamada externa retornou um texto e possui algum termo em especial.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Termo' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Termo', type: 'string' }
   ]
  },
  {
     apiId: 14,
     label: "Mensagem retorno última execução DovePL possui termo",
     description: "Verifica se o retorno da validação de dados DovePL possui algum termo em especial.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Termo' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Termo', type: 'string' }
   ]
  },
  {
     apiId: 15,
     label: "Origem da última mensagem enviada ao contato",
     description: "Consulta a origem da última mensagem enviada ao contato.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Origem (CAMPANHA / OPERACAO / SISTEMA / API)' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Origem (CAMPANHA / OPERACAO / SISTEMA / API)', type: 'string' },
      // Aqui, o 'id' original 'Intervalo de tempo em horas' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Intervalo de tempo em horas', type: 'string', placeholder: 'Ex: "> 10", "< 800"' }
   ]
  },
  {
     apiId: 16,
     label: "Última mensagem enviada ao contato possui termo",
     description: "Analisa se a última mensagem enviada para o contato possui o termo parametrizado.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Termo' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Termo', type: 'string' }
   ]
  },
  {
     apiId: 17,
     label: "Indício de Chatbot abandonado pelo contato",
     description: "Sistema verifica se o chatbot está sem resposta do contato e encaminha nova mensagem para retomar atendimento após um tempo definido.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de minutos' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de minutos', type: 'integer' },
      // Aqui, o 'id' original 'Identificador da etapa' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Identificador da etapa', type: 'string' }
   ]
  },
  {
     apiId: 18,
     label: "Etapa atual é recorrente",
     description: "Verifica quantas vezes o fluxo passou pela etapa atual (sem sair dela).",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de passagens' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de passagens', type: 'number' }
   ]
  },
  {
     apiId: 19,
     label: "CPF/CNPJ conhecido",
     description: "Verifica se o contato já possui identificação cadastrada no sistema.",
     apiType: 'condition',
     parameters: []
  },
  {
     apiId: 21,
     label: "Indício de Atendente abandonado pelo contato fidelizado",
     description: "Verifica se mensagem enviada pelo atendente não obteve resposta do contato.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de minutos' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de minutos', type: 'integer' }
   ]
  },
  {
     apiId: 22,
     label: "Contato possui evento",
     description: "Verifica se o cliente possui um evento específico lançado no período informado.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Código evento' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Código evento', type: 'string' },
      // Aqui, o 'id' original 'Intervalo de tempo em horas' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Intervalo de tempo em horas', type: 'string', placeholder: 'Ex: "> 10", "< 800"' }
   ]
  },
  {
     apiId: 25,
     label: "Ultimo evento do contato",
     description: "Verifica se o último evento lançado ao cliente é igual a um do(s) evento(s) de código informado(s).",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Código evento' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Código evento', type: 'string' },
      // Aqui, o 'id' original 'Evento finalizador (S/N)' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Evento finalizador (S/N)', type: 'string' }
   ]
  },
  {
     apiId: 26,
     label: "Mensagem possui arquivo",
     description: "Analisa se a mensagem do cliente possui um arquivo do tipo especificado no parâmetro.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Tipo arquivo (IMAGE / AUDIO / DOCUMENT / VIDEO / UNKNOWN)' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Tipo arquivo (IMAGE / AUDIO / DOCUMENT / VIDEO / UNKNOWN)', type: 'string' }
   ]
  },
  {
     apiId: 29,
     label: "Conteúdo da variável",
     description: "Verifica o valor da variável e retorna TRUE se a condição for satisfeita.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'nomevariavel' foi renomeado para 'Parametro1'
      { id: 'nomevariavel', name: 'Nome da variável', type: 'string' },
      // Aqui, o 'id' original 'comparacao' foi renomeado para 'Parametro2'
      { id: 'comparacao', name: 'Comparação', type: 'options', options: [{ title: "Contém", value: "contem" }, { title: "Igual à", value: "igual" }, { title: "Diferente de", value: "diferente" }, { title: "Menor que", value: "menor" }, { title: "Maior que", value: "maior" }, { title: "Variável sem conteúdo ou inexistente", value: "inexistente" }, { title: "Variável tem tamanho (quantidade de caracteres) maior ou igual à", value: "tamanhomaior" }] },
      { id: 'valorvariavel', name: 'Valor para comparação', type: 'string' }
   ]
  },
  {
     apiId: 30,
     label: "Hoje/Agora é",
     description: "Oferece uma série de verificações para a data de hoje.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'Data' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Data', type: 'date' },
      // Aqui, o 'id' original 'Hora inicial' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Hora inicial', type: 'time' },
      { id: 'Hora final', type: 'time' }
   ]
  },
  {
     apiId: 31,
     label: "Canal atual",
     description: "Verifica o canal atual de contato com o cliente.",
     apiType: 'condition',
     parameters: [
      // Aqui, o 'id' original 'canalatual' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Canal atual', type: 'options', options: [{ title: "Whatsapp", value: "whatsapp" }, { title: "WebChat", value: "webchat" }, { title: "E-Mail", value: "email" }, { title: "SMS", value: "sms" }, { title: "Messenger", value: "messenger" }, { title: "Instagram", value: "instagram" }, { title: "Telegram", value: "telegram" }, { title: "Viber", value: "viber" }, { title: "Voz", value: "voz" }] }
   ]
  },{
     apiId: 32,
     label: "Contato em atendimento pela operação (fidelizado)",
     description: "Verifica se o contato já está sendo atendido por um operador",
     apiType: 'condition',
     parameters: []
    
  }
 ],
 gatilhos: [
  {
     apiId: 1,
     label: "Mensagem Recebida",
     description: "Inicia o atendimento do Chatbot à partir de uma mensagem recebida.",
     apiType: 'trigger',
     parameters: [
      // Aqui, os 'id's originais foram renomeados para 'Parametro1' e 'Parametro2'
      { id: 'Parametro1', name: 'Hora inicial', type: "time" },
      { id: 'Parametro2', name: 'Hora final', type: "time" }
   ]
  },
  {
     apiId: 17,
     label: "Indício de Chatbot abandonado pelo contato",
     description: "Sistema verifica se o chatbot está sem resposta do contato e encaminha nova mensagem para retomar atendimento após um tempo definido.",
     apiType: 'trigger',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de minutos' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de minutos', type: "integer" },
      // Aqui, o 'id' original 'Identificador da etapa' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Identificador da etapa', type: "string" }
   ]
  },
  {
     apiId: 20,
     label: "Contato logou no chat",
     description: "Gatilho para envio de mensagem primaria antes mesmo de receber uma interação do contato.",
     apiType: 'trigger',
     parameters: [
      // Aqui, os 'id's originais foram renomeados para 'Parametro1' e 'Parametro2'
      { id: 'Parametro1', name: 'Hora inicial', type: "time" },
      { id: 'Parametro2', name: 'Hora final', type: "time" }
   ]
  },
  {
     apiId: 21,
     label: "Indício de Atendente abandonado pelo contato fidelizado",
     description: "Gatilho para envio de mensagem primária antes mesmo de receber uma interação do contato.",
     apiType: 'trigger',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de minutos apenas numeros (exemplo: 1,2,3)' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de minutos apenas numeros (exemplo: 1,2,3)', type: "integer" }
   ]
  },
  {
     apiId: 23,
     label: "Sessão de 24hrs do WhatsApp prestes a fechar",
     description: "Dispara quando janela de 24hrs do WhatsApp estiver próxima de fechar, podendo ser programado o envio de uma mensagem de estímulo.",
     apiType: 'trigger',
     parameters: [
      // Aqui, o 'id' original 'Quantidade de horas já decorridas' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Quantidade de horas já decorridas', type: 'number' }
   ]
  },
  {
     apiId: 24,
     label: "Fluxo disparado externamente",
     description: "Indica que o disparo de fluxo foi forçado externamente (API/outro fluxo).",
     apiType: 'trigger',
     parameters: [
      // Aqui, o 'id' original 'origem' foi renomeado para 'Parametro1'
      { id: 'Parametro1', name: 'Origem', type: "options-card", options: [{ title: "API", value: "api", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-invenio-api.png" }, { title: "Rd Station", value: "rd_station", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-rd-station.png" }, { title: "Shopify", value: "shopify", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-shopify.png" }, { title: "Monetize", value: "monetize", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-monetizze.png" }, { title: "WooCommerce", value: "woo_commerce", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-woo-commerce.png" }, { title: "Eduzz", value: "eduzz", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-eduzz.png" }, { title: "Hotmart", value: "hotmart", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-hotmart.png" }, { title: "Stripe", value: "stripe", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-stripe.png" }, { title: "ActiveCampaign", value: "activecampaign", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-activeCampaign.png" }, { title: "Nuvemshop", value: "nuvemshop", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-nuvemshop.png" }, { title: "MercadoPago", value: "mercadopago", url_logo: "https://robbublob.blob.core.windows.net/hospedagem-fixa/logo-idr-mercado-pago.png" }], default_value: "api" },
      // Aqui, o 'id' original 'webhook' foi renomeado para 'Parametro2'
      { id: 'Parametro2', name: 'Webhook', type: "string_copyable", depends_on: "Parametro1", depends_on_value: ["api", "rd_station", "shopify", "woo_commerce", "eduzz", "hotmart", "monetize", "stripe", "activecampaign", "nuvemshop", "mercadopago"] },
      { id: "token_api", name: "Token da API", type: "string", depends_on: "Parametro1", depends_on_value: "stripe" },
      { id: "nomePessoa_api", name: "Nome Pessoa ", type: "string", default_value: "contact.name", depends_on: "Parametro1", depends_on_value: "api" },
      { id: "cpfcnpj_api", name: "Documento ", type: "string", default_value: "contact.document", depends_on: "Parametro1", depends_on_value: "api" },
      { id: "telefone_api", name: "Telefone ", type: "string", default_value: "contact.channel.phone", depends_on: "Parametro1", depends_on_value: "api" },
      { id: "email_api", name: "E-mail ", type: "string", default_value: "contact.channel.email", depends_on: "Parametro1", depends_on_value: "api" },
      { id: "nuvemshop_sincronizar_nuvemshop", name: "Sincronizar com a Nuvemshop", type: "button_request", button_url: "https://www.tiendanube.com/apps/3751/authorize", button_target: "_blank", depends_on: "Parametro1", depends_on_value: "nuvemshop" },
      { id: "accessToken", name: "Access token", type: "string", depends_on: "Parametro1", depends_on_value: "mercadopago" }
   ]
  },
  {
     apiId: 35,
     label: "Ligação Interrompida",
     description: "Dispara quando um comando de encerramento da ligação é recebido.",
     apiType: 'trigger',
     parameters: []
  }
 ],
  
 // O MÓDULO DE ERRO SIMPLIFICADO POR ID
 moduloErro: 
   [
        {
            "action_id": 1,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10000.10000.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": [
                        {
                            "text": "Estamos passando por uma instabilidade no sistema, e não consegui concluir a sua solicitação 😣.\n\n*Por favor, tente novamente em alguns minutos.*"
                        }
                    ],
                    "type": "array-text"
                },
                {
                    "id": "canal",
                    "value": "canalatual",
                    "type": "options"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "numerolinha",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "numerolinhamanual",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "templatewhatsapp",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "templateemail",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "diasadiamentodisparo",
                    "value": "",
                    "type": "integer"
                },
                {
                    "id": "horadisparoadiado",
                    "value": "",
                    "type": "hour"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10000.10000.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Algo Mais",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 18,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10000.10000",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "2",
                    "type": "integer"
                }
            ],
            "result": true,
            "type": 1
        },
        {
            "action_id": 1,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10000.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": [
                        {
                            "text": "Aguarde um momento..."
                        }
                    ],
                    "type": "array-text"
                },
                {
                    "id": "canal",
                    "value": "canalatual",
                    "type": "options"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "numerolinha",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "numerolinhamanual",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "templatewhatsapp",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "templateemail",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "diasadiamentodisparo",
                    "value": "",
                    "type": "integer"
                },
                {
                    "id": "horadisparoadiado",
                    "value": "",
                    "type": "hour"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 15,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10000.10002",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "UnidadeMedida",
                    "value": "segundos",
                    "type": "options"
                },
                {
                    "id": "Parametro1",
                    "value": "5",
                    "type": "string"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10000.10003",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "{{API Atual}}",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Módulo Erro API",
            "id": null,
            "identifier": "10000.10000.10000",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro API",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10001.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Tipo Erro ",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "Mensagem",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10001.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verificação Quantidade Erros",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Módulo Erro Mensagem",
            "id": null,
            "identifier": "10000.10000.10001",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro Mensagem",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10002.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Tipo Erro",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "Numérico",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10002.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verificação Quantidade Erros",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Módulo Erro Numérico",
            "id": null,
            "identifier": "10000.10000.10002",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro Numérico",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10003.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Tipo Erro",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "Lista",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10003.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verificação Quantidade Erros",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Módulo Erro Lista",
            "id": null,
            "identifier": "10000.10000.10003",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro Lista",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10004.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Tipo Erro",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "Botões",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10004.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verificação Quantidade Erros",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Módulo Erro Botões",
            "id": null,
            "identifier": "10000.10000.10004",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro Botões",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10005.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Tipo Erro",
                    "type": "string"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "CPF",
                    "type": "text"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10005.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verificação Quantidade Erros",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Módulo Erro CPF",
            "id": null,
            "identifier": "10000.10000.10005",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro CPF",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10000.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Comparador Etapa",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "{{Pergunta Atual}}",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10000.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Quantidade Erros",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "0",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10000.10002",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Inicia Contagem Erro",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 29,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10000",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "{{Pergunta Atual}}",
                    "type": "string"
                },
                {
                    "id": "comparacao",
                    "value": "igual",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "{{Comparador Etapa}}",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10001.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Quantidade Erros",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "0",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "salvar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10001.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro Persistente",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 29,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10001",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "{{Quantidade Erros}}",
                    "type": "string"
                },
                {
                    "id": "comparacao",
                    "value": "maior",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "1",
                    "type": "string"
                }
            ],
            "result": true,
            "type": 1
        },
        {
            "action_id": 20,
            "condition_id": null,
            "description": "Inicia Contagem Erro",
            "id": null,
            "identifier": "10000.10000.10006.10002",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "Quantidade Erros",
                    "type": "string"
                },
                {
                    "id": "valorvariavel",
                    "value": "1",
                    "type": "text"
                },
                {
                    "id": "operacao",
                    "value": "adicionar",
                    "type": "options"
                },
                {
                    "id": "tipovariavel",
                    "value": "local",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10006.10003",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verifica Tipo Erro",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Verificação Quantidade Erros",
            "id": null,
            "identifier": "10000.10000.10006",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verificação Quantidade Erros",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 1,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10000.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": [
                        {
                            "text": "Desculpe, não entendi. 😥\n\nPor gentileza, *responda a ultima pergunta*.\n\n"
                        }
                    ],
                    "type": "array-text"
                },
                {
                    "id": "canal",
                    "value": "canalatual",
                    "type": "options"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "numerolinha",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "numerolinhamanual",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "templatewhatsapp",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "templateemail",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "diasadiamentodisparo",
                    "value": "",
                    "type": "integer"
                },
                {
                    "id": "horadisparoadiado",
                    "value": "",
                    "type": "hour"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10000.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "@identificadororiginal",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 29,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10000",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "{{Tipo Erro}}",
                    "type": "string"
                },
                {
                    "id": "comparacao",
                    "value": "igual",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "Mensagem",
                    "type": "string"
                }
            ],
            "result": true,
            "type": 1
        },
        {
            "action_id": 1,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10001.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": [
                        {
                            "text": "Desculpe, não entendi. 😥\n\nPor gentileza, *responda apenas com números*."
                        }
                    ],
                    "type": "array-text"
                },
                {
                    "id": "canal",
                    "value": "canalatual",
                    "type": "options"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "numerolinha",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "numerolinhamanual",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "templatewhatsapp",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "templateemail",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "diasadiamentodisparo",
                    "value": "",
                    "type": "integer"
                },
                {
                    "id": "horadisparoadiado",
                    "value": "",
                    "type": "hour"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10001.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "{{Pergunta Atual}}",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 29,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10001",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "{{Tipo Erro}}",
                    "type": "string"
                },
                {
                    "id": "comparacao",
                    "value": "igual",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "Numérico",
                    "type": "string"
                }
            ],
            "result": true,
            "type": 1
        },
        {
            "action_id": 1,
            "condition_id": null,
            "description": "Enviar Mensagem Erro Lista",
            "id": null,
            "identifier": "10000.10000.10007.10002.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": [
                        {
                            "text": "Desculpe, não entendi. 😥\n\nPor gentileza, *selecione uma opção da lista a seguir*."
                        }
                    ],
                    "type": "array-text"
                },
                {
                    "id": "canal",
                    "value": "canalatual",
                    "type": "options"
                },
                {
                    "id": "aprimorar",
                    "value": "nao",
                    "type": "options"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "numerolinha",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "numerolinhamanual",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "templatewhatsapp",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "templateemail",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "diasadiamentodisparo",
                    "value": "",
                    "type": "integer"
                },
                {
                    "id": "horadisparoadiado",
                    "value": "",
                    "type": "hour"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 15,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10002.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "2",
                    "type": "string"
                },
                {
                    "id": "UnidadeMedida",
                    "value": "segundos",
                    "type": "options"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10002.10002",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "{{Pergunta Atual}}",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 29,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10002",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "{{Tipo Erro}}",
                    "type": "string"
                },
                {
                    "id": "comparacao",
                    "value": "igual",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "Lista",
                    "type": "string"
                }
            ],
            "result": true,
            "type": 1
        },
        {
            "action_id": 1,
            "condition_id": null,
            "description": "Enviar Mensagem Erro Botões",
            "id": null,
            "identifier": "10000.10000.10007.10003.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": [
                        {
                            "text": "Desculpe, não entendi. 😥\n\nPor gentileza, *selecione um botão da mensagem a seguir*."
                        }
                    ],
                    "type": "array-text"
                },
                {
                    "id": "canal",
                    "value": "canalatual",
                    "type": "options"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "numerolinha",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "numerolinhamanual",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "templatewhatsapp",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "templateemail",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "diasadiamentodisparo",
                    "value": "",
                    "type": "integer"
                },
                {
                    "id": "horadisparoadiado",
                    "value": "",
                    "type": "hour"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 15,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10003.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "UnidadeMedida",
                    "value": "segundos",
                    "type": "options"
                },
                {
                    "id": "Parametro1",
                    "value": "2",
                    "type": "string"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10003.10002",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "{{Pergunta Atual}}",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 29,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10003",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "{{Tipo Erro}}",
                    "type": "string"
                },
                {
                    "id": "comparacao",
                    "value": "igual",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "Botões",
                    "type": "string"
                }
            ],
            "result": true,
            "type": 1
        },
        {
            "action_id": 1,
            "condition_id": null,
            "description": "Enviar Mensagem Erro CPF",
            "id": null,
            "identifier": "10000.10000.10007.10004.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": [
                        {
                            "text": "Documento inválido. 😥 \n\nPor gentileza, *digite apenas os números do seu CPF*:"
                        }
                    ],
                    "type": "array-text"
                },
                {
                    "id": "canal",
                    "value": "canalatual",
                    "type": "options"
                },
                {
                    "id": "aprimorar",
                    "value": "nao",
                    "type": "options"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "numerolinha",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "numerolinhamanual",
                    "value": "",
                    "type": "string"
                },
                {
                    "id": "templatewhatsapp",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "templateemail",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "diasadiamentodisparo",
                    "value": "",
                    "type": "integer"
                },
                {
                    "id": "horadisparoadiado",
                    "value": "",
                    "type": "hour"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10004.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "@identificadororiginal",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 29,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10007.10004",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "nomevariavel",
                    "value": "{{Tipo Erro}}",
                    "type": "string"
                },
                {
                    "id": "comparacao",
                    "value": "igual",
                    "type": "options"
                },
                {
                    "id": "valorvariavel",
                    "value": "CPF",
                    "type": "string"
                }
            ],
            "result": true,
            "type": 1
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Verifica Tipo Erro",
            "id": null,
            "identifier": "10000.10000.10007",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Verifica Tipo Erro",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": 22,
            "condition_id": null,
            "description": "",
            "id": null,
            "identifier": "10000.10000.10008.10000",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "InteractiveButton",
                    "value": {
                        "type": "button",
                        "header": {
                            "type": "text",
                            "text": "Erro..."
                        },
                        "body": {
                            "text": "Desculpe, não estou conseguinto entender o que você está digitando.\n\n*O que você quer fazer agora?*"
                        },
                        "footer": {
                            "text": ""
                        },
                        "action": {
                            "buttons": [
                                {
                                    "localId": "4811c4ad-bcd8-447f-be01-9bbda89f7ddb",
                                    "order": 0,
                                    "type": "reply",
                                    "reply": {
                                        "id": "Menu Inicial",
                                        "title": "Nova Solicitação"
                                    }
                                },
                                {
                                    "localId": "77cd5e2f-4cd2-4ccf-8ee5-a2696477904d",
                                    "order": 1,
                                    "type": "reply",
                                    "reply": {
                                        "id": "Falar com Atendente",
                                        "title": "Falar com Atendente"
                                    }
                                },
                                {
                                    "localId": "a3a45c27-48b6-48f4-abab-5be81bd35c2b",
                                    "order": 2,
                                    "type": "reply",
                                    "reply": {
                                        "id": "SAIR",
                                        "title": "❌ Encerrar conversa"
                                    }
                                }
                            ]
                        }
                    },
                    "type": "interactive-button"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 2,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10008.10001",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "ParametrosVoice",
                    "value": "nao",
                    "type": "options"
                },
                {
                    "id": "grammar",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "confidence",
                    "value": "",
                    "type": "options"
                },
                {
                    "id": "timeout",
                    "value": "",
                    "type": "integer"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": 10,
            "condition_id": null,
            "description": null,
            "id": null,
            "identifier": "10000.10000.10008.10002",
            "open": true,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Menu Inicial",
                    "type": "step"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "flow"
                }
            ],
            "result": null,
            "type": 2
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Módulo Erro Persistente",
            "id": null,
            "identifier": "10000.10000.10008",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erro Persistente",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": false,
            "type": 1
        },
        {
            "action_id": null,
            "condition_id": 25,
            "description": "Comentário: Módulo de Input Inesperado, termos não previstos.",
            "id": null,
            "identifier": "10000.10000",
            "open": false,
            "parallel_flow": false,
            "parameters": [
                {
                    "id": "Parametro1",
                    "value": "Módulo Erros",
                    "type": "string"
                },
                {
                    "id": "Parametro2",
                    "value": "",
                    "type": "string"
                }
            ],
            "result": true,
            "type": 1
        }
		
	],
	moduloMensagem: 
               [
        [
            {"action_id":1},
            {"action_id": 20},
            {"action_id": 2},
 
        ]


    ]


 }
 
 
 